import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {PostLoginCB} from "../../ope/user/PostLoginCB";
import {GetUsersCB} from "../../ope/user/GetUsersCB";
import {GetVisibleUsersCB} from "../../ope/user/GetVisibleUsersCB";
import {PutUserCB} from "../../ope/user/PutUserCB";
import {DelUserCB} from "../../ope/user/DelUserCB";
import {UpdateUserPartitionCB} from "../../ope/user/UpdateUserPartitionCB";
import {GetUserMetricGroupCB} from "../../ope/user/metric/GetUserMetricGroupCB";
import {GetAllUserMetricGroupCB} from "../../ope/user/metric/GetAllUserMetricGroupCB";
import {GetUserMetricGroupsCB} from "../../ope/user/metric/GetUserMetricGroupsCB";
import {GetAllUserMetricGroupsCB} from "../../ope/user/metric/GetAllUserMetricGroupsCB";
import {ShareUserMetricGroupCB} from "../../ope/user/metric/ShareUserMetricGroupCB";
import {ValidateShareUserMetricGroupDraftCB} from "../../ope/user/metric/ValidateShareUserMetricGroupDraftCB";
import {PutUserMetricGroupCB} from "../../ope/user/metric/PutUserMetricGroupCB";
import {DelUserMetricGroupCB} from "../../ope/user/metric/DelUserMetricGroupCB";
import {SetUserLanguageCB} from "../../ope/user/SetUserLanguageCB";
import {RefreshPushNotificationTokenCB} from "../../ope/user/RefreshPushNotificationTokenCB";
import {SendUserWelcomeEmailCB} from "../../ope/user/SendUserWelcomeEmailCB";

@Injectable({
  providedIn: 'root'
})
export class UserOpeService extends BaseOPEService {

  public getUsers(cb: GetUsersCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getVisibleUsers(cb: GetVisibleUsersCB, showSpinner: boolean = true): Promise<any> {
    return this.execOPE(cb, showSpinner);
  }

  public getUserMetricGroup(cb: GetUserMetricGroupCB) {
    return this.execOPE(cb);
  }

  public putUserMetricGroup(cb: PutUserMetricGroupCB) {
    return this.execOPE(cb);
  }

  public getUserMetricGroups(cb: GetUserMetricGroupsCB) {
    return this.execOPE(cb);
  }

  // Impersonation-aware variants: same data, but for the charts of another user too.
  public getAllUserMetricGroup(cb: GetAllUserMetricGroupCB) {
    return this.execOPE(cb);
  }

  public getAllUserMetricGroups(cb: GetAllUserMetricGroupsCB) {
    return this.execOPE(cb);
  }

  public shareUserMetricGroup(cb: ShareUserMetricGroupCB) {
    return this.execOPE(cb);
  }

  public validateShareUserMetricGroupDraft(cb: ValidateShareUserMetricGroupDraftCB) {
    return this.execOPE(cb);
  }

  public putUser(cb: PutUserCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delUser(cb: DelUserCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delUserMetricGroup(cb: DelUserMetricGroupCB) {
    return this.execOPE(cb);
  }

  public postLogin(cb: PostLoginCB): Promise<any> {
    return this.execOPE(cb);
  }

  public updateUserPartition(cb: UpdateUserPartitionCB) {
    return this.execOPE(cb);
  }

  public setUserLanguage(cb: SetUserLanguageCB) {
    return this.execOPE(cb);
  }

  public refreshPushNotificationToken(cb: RefreshPushNotificationTokenCB) {
    return this.execOPE(cb);
  }

  public sendUserWelcomeEmail(cb: SendUserWelcomeEmailCB): Promise<any> {
    return this.execOPE(cb);
  }
}
